/** Decompressed wire bytes, independent from the retained DTO cache budget. */
export const CITY_SCENE_RESPONSE_BYTE_LIMIT=48*1024*1024;
